import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  const staggerChildren = {
    visible: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h3 className="text-white font-display text-xl font-semibold mb-4">
              Yahşi Veteriner Kliniği
            </h3>
            <p className="text-gray-400 mb-4">
            2023'den beri evcil dostlarınızın sağlığı için profesyonel veterinerlik hizmetleri sunuyoruz.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors duration-200"
              >
                <FaFacebook size={24} />
              </a>
              <a
                href="https://instagram.com/yahsiveterinerklinigi"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors duration-200"
              >
                <FaInstagram size={24} />
              </a>
              <a
                href="https://wa.me/905533077616"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <FaWhatsapp size={24} />
              </a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h3 className="text-white font-display text-xl font-semibold mb-4">
              Hızlı Bağlantılar
            </h3>
            <motion.ul variants={staggerChildren} className="space-y-2">
              <motion.li variants={fadeInUp}>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  Ana Sayfa
                </Link>
              </motion.li>
              <motion.li variants={fadeInUp}>
                <Link
                  to="/hizmetler"
                  className="text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  Hizmetlerimiz
                </Link>
              </motion.li>
              <motion.li variants={fadeInUp}>
                <Link
                  to="/hakkimizda"
                  className="text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  Hakkımızda
                </Link>
              </motion.li>
              <motion.li variants={fadeInUp}>
                <Link
                  to="/iletisim"
                  className="text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  İletişim
                </Link>
              </motion.li>
            </motion.ul>
          </motion.div>

          {/* Services */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h3 className="text-white font-display text-xl font-semibold mb-4">
              Hizmetlerimiz
            </h3>
            <motion.ul variants={staggerChildren} className="space-y-2">
              <motion.li variants={fadeInUp}>
                <Link
                  to="/hizmetler#genel-muayene"
                  className="text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  Genel Muayene
                </Link>
              </motion.li>
              <motion.li variants={fadeInUp}>
                <Link
                  to="/hizmetler#asilar"
                  className="text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  Aşılama
                </Link>
              </motion.li>
              <motion.li variants={fadeInUp}>
                <Link
                  to="/hizmetler#cerrahi"
                  className="text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  Cerrahi Operasyonlar
                </Link>
              </motion.li>
              <motion.li variants={fadeInUp}>
                <Link
                  to="/hizmetler#laboratuvar"
                  className="text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  Laboratuvar
                </Link>
              </motion.li>
            </motion.ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h3 className="text-white font-display text-xl font-semibold mb-4">
              İletişim
            </h3>
            <motion.ul variants={staggerChildren} className="space-y-4">
              <motion.li variants={fadeInUp} className="flex items-start">
                <FaMapMarkerAlt className="text-primary mt-1 mr-3" />
                <span className="text-gray-400">
                  Demirtaş Cumhuriyet mahallesi 1205 sokak<br />
                  16000 Osmangazi / Bursa
                </span>
              </motion.li>
              <motion.li variants={fadeInUp}>
                <a
                  href="tel:+905533077616"
                  className="text-gray-400 hover:text-white transition-colors flex items-center mt-2"
                >
                  <FaPhone className="mr-2" />
                  <span>0553 307 76 16</span>
                </a>
              </motion.li>
              <motion.li variants={fadeInUp}>
                <a
                  href="mailto:musayahsi18@gmail.com"
                  className="flex items-center text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  <FaEnvelope className="mr-3" />
                  <span>musayahsi18@gmail.com</span>
                </a>
              </motion.li>
            </motion.ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} Yahşi Veteriner Kliniği. Tüm hakları saklıdır.
            </p>
            <div className="flex space-x-4">
              <Link
                to="/gizlilik-politikasi"
                className="text-gray-400 hover:text-primary text-sm transition-colors duration-200"
              >
                Gizlilik Politikası
              </Link>
              <Link
                to="/kullanim-kosullari"
                className="text-gray-400 hover:text-primary text-sm transition-colors duration-200"
              >
                Kullanım Koşulları
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 